<template>
  <div :class="$attrs.class">
    <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-group tw-w-full tw-flex tw-flex-col tw-flex-1">
      <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
        <img 
          :alt="product.name+' image'"
          class="tw-scale-105 tw-h-full tw-w-full group-hover:tw-scale-125 tw-transition-all tw-duration-300 tw-ease-out"
          :src="productImage">
      </div>
      
      <div class="tw-px-8 tw-py-8 tw-text-center tw-w-full tw-flex tw-flex-col tw-justify-between tw-flex-1">
        <div class="tw-flex tw-flex-col tw-flex-1">
          <div class="tw-font-black tw-text-black tw-text-lg tw-uppercase tw-text-center">{{product.name}}</div>
          <div class="tw-text-lg tw-text-gray-500 tw-text-center tw-mb-4">${{product.cost.toFixed(2)}}</div>
        </div>
        
        <div class="tw-flex tw-flex-col tw-flex-1 tw-justify-end">
          <template v-if="props.size == 'full'">
            <div class="tw-flex-1 tw-mx-4 tw-flex tw-justify-center">
              <div class="tw-flex tw-justify-center tw-items-center tw-border-2 tw-border-orange-medium tw-rounded-2xl">
                <button
                  @click="decrementQuantity"
                  class="tw-px-4 tw-text-2xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black">
                  &mdash;
                </button>
                <label class="tw-mb-0">{{state.quantity}}</label>
                <button
                  @click="incrementQuantity"
                  class="tw-px-4 tw-text-3xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black">
                  +
                </button>
                <TwButton
                  cssClass="tw-bg-orange-medium hover:tw-bg-orange-dark tw-text-white tw-text-3xl tw-uppercase tw-font-bold tw-px-4 tw-py-2 tw-transition-all tw-duration-200 tw-uppercase"
                  @click="handleClick"
                  buttonText="Add" />
              </div>
            </div>
          </template>
          <div class="tw-text-center" v-else>
            <TwButton
              cssClass="tw-rounded-full tw-bg-orange-medium hover:tw-bg-orange-dark tw-text-white tw-text-xl tw-uppercase tw-font-bold tw-px-4 tw-py-2 tw-transition-all tw-duration-200 tw-uppercase"
              @click="handleClick"
              :isLoading="props.isLoading"
              buttonText="Add To Bag" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed, reactive } from 'vue'
  import { useRouter } from 'vue-router'
  import type Product from '../../classes/Product';

  const props = defineProps<{ product: Product, size: String, isLoading: boolean }>();

  import TwButton from '../../components/TwButton.vue';

  const productImage = ref();

  const state = reactive({
     quantity: 1,
     addingToBag: false,
   })

  const router = useRouter();

  const emit = defineEmits(['handleProductAdd'])

  onMounted(() => {
    if (props.product != null) {
      state.quantity = props.product.quantity;

      if (props.product.images) {
        let img = props.product.getImageByKey("product_web_category")

        if (img) {
          productImage.value = img.url
        } else {
          productImage.value = 'https://mypiada-assets.s3.amazonaws.com/static_assets/scooter-placeholder.jpg';
        }
      } else {
        productImage.value = 'https://mypiada-assets.s3.amazonaws.com/static_assets/scooter-placeholder.jpg';
      }
    }
  })

  const currentPrice = computed(() => {
    let calculatedCost = 0.00;
    if (props.product) {
      calculatedCost += props.product.cost! as number
    }

    return calculatedCost * state.quantity;
  })

  const decrementQuantity = () => {
    state.quantity = Math.max(state.quantity -= 1, 1);
  };

  const incrementQuantity = () => {
    state.quantity = Math.min(state.quantity += 1, 99);
  };

  const handleClick = (event: Event) => {
    emit('handleProductAdd', props.product.id!.toString())
  }

</script>
